import * as Sentry from '@sentry/react';
import { useMemo } from 'react';

import type { User } from '~/contexts/UserAuthProvider';

// Exports
export const useIdentifySentryUser = () => {
  return useMemo(
    () => ({
      identifySentryUser: (user: User) => {
        Sentry.setUser({
          id: user.id,
          organization: user.organization.slug,
        });
      },
    }),
    [],
  );
};
